import { Injectable } from '@angular/core';
import * as moment from "moment";
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TimeLogEventHandler {
  private timeAddedEventSubject = new Subject<any>();
  private timeUpdatedEventSubject = new Subject<any>();
  private timeDeletedEventSubject = new Subject<number>();

  notifyTimeAdded(time: any) {
    this.timeAddedEventSubject.next(time);
  }

  notifyTimeUpdated(time: any) {
    this.timeUpdatedEventSubject.next(time);
  }

  notifyTimeDeleted(id: number) {
    this.timeDeletedEventSubject.next(id);
  }

  onTimeAdded() {
    return this.timeAddedEventSubject.asObservable();
  }

  onTimeUpdated() {
    return this.timeUpdatedEventSubject.asObservable();
  }

  onTimeDeleted() {
    return this.timeDeletedEventSubject.asObservable();
  }
}